"use strict";
var sass_alias_1 = require("./sass-alias");
module.exports = sass_alias_1.SassAlias;
//# sourceMappingURL=index.js.map